import { render, staticRenderFns } from "./PreferencesModel.vue?vue&type=template&id=77183289&scoped=true&"
import script from "./PreferencesModel.vue?vue&type=script&lang=js&"
export * from "./PreferencesModel.vue?vue&type=script&lang=js&"
import style0 from "./PreferencesModel.vue?vue&type=style&index=0&id=77183289&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77183289",
  null
  
)

export default component.exports